import { paginationFlaws } from './appFlawCatalog/pagination.js';
import { featuresFlaws } from './appFlawCatalog/features.js';
import { argumentsFlaws } from './appFlawCatalog/arguments.js';
import { responseFlaws } from './appFlawCatalog/response.js';
import { structureFlaws } from './appFlawCatalog/structure.js';
import { freezeAppFlawValue } from './appFlawCatalog/freezeAppFlawValue.js';

const APP_FLAW_CATALOG_VERSION = '2';
const APP_FLAW_SOURCES = Object.freeze(['classifier', 'code', 'cirra-agent', 'admin']);
const APP_FLAW_DISMISSAL_REASONS = Object.freeze(['false_positive', 'provider_unsupported', 'not_reproducible', 'out_of_scope', 'already_fixed']);
const APP_FLAW_RETRY_REASONS = Object.freeze(['transient_run_failure', 'missing_credential', 'provider_outage']);
const APP_FLAW_DEFAULT_MAX_ATTEMPTS = 3;
const appFlawCatalog = freezeAppFlawValue(Object.fromEntries([...paginationFlaws, ...featuresFlaws, ...argumentsFlaws, ...responseFlaws, ...structureFlaws].map((flaw) => [flaw.slug, flaw])));
const APP_FLAW_SLUGS = Object.freeze(Object.keys(appFlawCatalog));
const APP_FLAW_REQUEST_SLUGS = Object.freeze(APP_FLAW_SLUGS.filter((slug) => slug !== 'OTHER'));
const APP_FLAW_CLASSIFIER_VALUES = Object.freeze([...APP_FLAW_SLUGS.filter((slug) => appFlawCatalog[slug].detectionModes.includes('classifier')), 'good_call']);
const APP_FLAW_LEGACY_MAPPING = freezeAppFlawValue(
  Object.values(appFlawCatalog).reduce((mapping, flaw) => {
    for (const legacyCode of flaw.legacyCodes) {
      mapping[legacyCode] ??= [];
      mapping[legacyCode].push(flaw.slug);
    }
    return mapping;
  }, {})
);

export { APP_FLAW_CATALOG_VERSION, APP_FLAW_SOURCES, APP_FLAW_DISMISSAL_REASONS, APP_FLAW_RETRY_REASONS, APP_FLAW_DEFAULT_MAX_ATTEMPTS, appFlawCatalog, APP_FLAW_SLUGS, APP_FLAW_REQUEST_SLUGS, APP_FLAW_CLASSIFIER_VALUES, APP_FLAW_LEGACY_MAPPING };
